import { useCallback, useEffect } from 'react'

import { createFileRoute, redirect } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'

import { useSignUp } from '@clerk/react'
import { Loader2 } from 'lucide-react'
import z from 'zod'

import { useAppLoader } from '@/features/app-shell/app-loader-context'

import { Title } from '@/shared/auth/components/common/card'
import { AuthPendingComponent } from '@/shared/auth/components/common/pending-component'

const searchSchema = z.object({
	token: z.string(),
})

export const Route = createFileRoute('/signup/azure/')({
	validateSearch: zodValidator(searchSchema),

	beforeLoad: ({ search }) => {
		// TODO: redirect to our Azure Marketplace offer page
		if (!search.token) {
			throw redirect({
				to: '/login',
				replace: true,
			})
		}
	},

	component: RouteComponent,
	pendingComponent: AuthPendingComponent,
})

function RouteComponent() {
	const { token } = Route.useSearch()
	const { hideLoader } = useAppLoader()

	const { signUp, fetchStatus } = useSignUp()

	const isSignUpLoaded = fetchStatus === 'idle'

	const handleSignUp = useCallback(async () => {
		if (isSignUpLoaded) {
			await signUp.sso({
				strategy: 'oauth_microsoft',
				redirectUrl: `/signup/azure/callback?token=${token}`,
				redirectCallbackUrl: `/signup/azure/confirm?token=${token}`,
				oidcPrompt: 'consent',
			})
		}
	}, [isSignUpLoaded, signUp, token])

	useEffect(() => {
		if (isSignUpLoaded) {
			hideLoader()
			// If user is not signed in, authenticate with Microsoft
			handleSignUp()
		}
	}, [isSignUpLoaded, handleSignUp, hideLoader])

	return (
		<>
			<Title>Confirm your subscription</Title>

			<Loader2 className="repeat-infinite mx-auto mt-8 h-6 w-6 animate-spin text-gray-600" />

			<div id="clerk-captcha" data-cl-theme="dark" data-cl-size="flexible" />
		</>
	)
}
